<template>
    <div>
        <div class="page-top mb-1 mb-3">
            <h1> Edit FAQ</h1>
        </div>
        <div class="global-main">
            <form @submit.prevent="editFaqData">
                <div class="tab-content-inner">
                    <div class="form-group">
                        <label> FAQ Categiory </label>
                        <select v-model="form.faq_category" name="faq_category" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('faq_category') }" v-if="faqCategories != null">
                            <option value="" selected>Select Category</option>
                            <option v-for="faqCategory in faqCategories" v-bind:value="faqCategory.id" v-bind:key="faqCategory.id">
                                {{ faqCategory.name }}
                            </option>
                        </select>
                        <has-error :form="form" field="faq_category"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Question </label>
                        <input v-model="form.faq_question" type="text" name="faq_question" class="form-control" :class="{ 'is-invalid': form.errors.has('faq_question') }">
                        <has-error :form="form" field="faq_question"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Answer </label>
                         <textarea v-model="form.faq_answer" rows="5" cols="5" name="faq_answer" class="form-control"
                         :class="{ 'is-invalid': form.errors.has('faq_answer') }"></textarea>
                        <has-error :form="form" field="faq_answer"></has-error>
                    </div>
                </div>
                <div class="form-group">
                        <label> Status </label>
                        <select v-model="form.faq_status" name="faq_status" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('faq_status') }">
                            <option value="ACTIVE" :selected="form.faq_status === 'ACTIVE'" >Active</option>>
                            <option value="INACTIVE" :selected="form.faq_status === 'ACTIVE'">Inactive</option>
                        </select>
                        <has-error :form="form" field="faq_status"></has-error>
                    </div>
                <div class="form-group">
                    <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                    <router-link to="/faqs" class="btn btn-primary float-right mr-2">Cancel</router-link>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    faq_question : '',
                    faq_answer : '',
                    faq_category : '',
                    faq_status : '',
                }),
                faqCategories: null,
            };
        },
        methods: {
            editFaqData() {
                this.$Progress.start();
                this.form.put('/api/updateFaqAPI')
                    .then(res => {
                        if(res.status == 200){
                            this.$Progress.finish();
                            this.showToastBox('success','FAQ updated successfully');                            
                            this.$router.push('/faqs');
                        }else{
                            this.$Progress.fail();
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');

                    });
            },
            getFaqCategories(){
                this.$Progress.start();
                axios.get('/api/getFaqCategoryAPI')
                .then(res => {
                    this.$Progress.finish();
                    this.faqCategories = res.data.record;
                }).then(res=>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            }
        },
        mounted() {
            this.getFaqCategories();

        },
        created() {
            this.$Progress.start();
            axios.get('/api/editFaq/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        this.form.id = res.data.id;
                        this.form.faq_category = res.data.faq_category;
                        this.form.faq_answer = res.data.faq_answer;
                        this.form.faq_question = res.data.faq_question;
                        this.form.faq_status = res.data.status;
                    
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
        }
    }
</script>
